// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"840":"d7615dc3","909":"e34e0821"}[chunkId] + ".css";
};